module.exports = __webpack_public_path__ + "static/media/25.b6103897.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/25.jpg
// module id = 286
// module chunks = 0